export const SUBSCRIBE_ENDPOINT = 'newsletter-subscribers';
export const CONTACT_FORM_ENDPOINT = 'contact-form';
export const TRAINING_FORM_ENDPOINT = 'contact-form';

export const COUNTRIES_ENDPOINT = 'countries/countries.json';
export const STATES_ENDPOINT = 'countries/states.json';
export const CITIES_ENDPOINT = 'countries/cities.json';